import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../../api";
import { useAuth } from "../../context/AuthContext";
import CampoPassword from "../../components/admin/CampoPassword";
import toast from "react-hot-toast";
import "./Login.css";

export default function Login() {
  const [paso, setPaso] = useState(1);
  const [form, setForm] = useState({ username: "", password: "" });
  const [codigo, setCodigo] = useState(["", "", "", "", "", ""]);
  const [tempToken, setTempToken] = useState("");
  const [cargando, setCargando] = useState(false);
  const { iniciarSesion, usuario } = useAuth();
  const navigate = useNavigate();
  const inputsRef = useRef([]);

  useEffect(() => {
    if (usuario) navigate("/admin/dashboard");
  }, [usuario, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!form.username || !form.password) {
      toast.error("Usuario y contraseña son requeridos");
      return;
    }
    setCargando(true);
    try {
      const res = await authAPI.login(form);
      const { requiere2fa, tempToken: tt, accessToken, usuario: u } = res.data;
      if (requiere2fa) {
        setTempToken(tt);
        setPaso(2);
        toast("Ingresa el código de Google Authenticator", { icon: "🔐" });
      } else {
        iniciarSesion(accessToken, u);
        navigate("/admin/dashboard");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Usuario o contraseña incorrectos");
    } finally {
      setCargando(false);
    }
  };

  const handleCodigoChange = (idx, val) => {
    if (!/^\d?$/.test(val)) return;
    const nuevo = [...codigo];
    nuevo[idx] = val;
    setCodigo(nuevo);
    if (val && idx < 5) inputsRef.current[idx + 1]?.focus();
  };

  const handleCodigoPaste = (e) => {
    const pegado = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (pegado.length === 6) {
      setCodigo(pegado.split(""));
      inputsRef.current[5]?.focus();
    }
  };

  const handleCodigoKey = (idx, e) => {
    if (e.key === "Backspace" && !codigo[idx] && idx > 0) {
      inputsRef.current[idx - 1]?.focus();
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    const code = codigo.join("");
    if (code.length !== 6) { toast.error("Ingresa los 6 dígitos"); return; }
    setCargando(true);
    try {
      const res = await authAPI.verify2fa({ tempToken, code });
      iniciarSesion(res.data.accessToken, res.data.usuario);
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.message || "Código incorrecto");
      setCodigo(["", "", "", "", "", ""]);
      inputsRef.current[0]?.focus();
    } finally {
      setCargando(false);
    }
  };

  return (
      <div className="login-page">
        <div className="login-card card">
          <div className="login-header">
            <div className="login-logo">🏠</div>
            <h1 className="heading-serif login-title">Panel Inmobiliaria</h1>
            <p className="login-sub">
              {paso === 1 ? "Ingresa tus credenciales" : "Autenticación de dos factores"}
            </p>
          </div>

          {paso === 1 ? (
              <form onSubmit={handleLogin} className="login-form">
                <div className="form-group">
                  <label className="form-label" htmlFor="login-usuario">Usuario</label>
                  <input
                      id="login-usuario"
                      type="text"
                      className="form-input"
                      value={form.username}
                      onChange={(e) => setForm({ ...form, username: e.target.value })}
                      placeholder="tu_usuario"
                      autoComplete="username"
                      autoFocus
                      autoCapitalize="none"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="login-password">Contraseña</label>
                  <CampoPassword
                      id="login-password"
                      value={form.password}
                      onChange={(e) => setForm({ ...form, password: e.target.value })}
                      placeholder="••••••••••••"
                      autoComplete="current-password"
                  />
                </div>
                <button
                    type="submit"
                    className="btn btn-primary btn-lg"
                    style={{ width: "100%" }}
                    disabled={cargando}
                >
                  {cargando ? "Verificando..." : "Iniciar sesión →"}
                </button>
              </form>
          ) : (
              <form onSubmit={handleVerify} className="login-form">
                <div className="totp-info">
                  <span style={{ fontSize: "2rem" }}>📱</span>
                  <p>Abre <strong>Google Authenticator</strong> e ingresa el código de 6 dígitos.</p>
                </div>
                <div className="otp-inputs" onPaste={handleCodigoPaste}>
                  {codigo.map((d, i) => (
                      <input
                          key={i}
                          ref={(el) => (inputsRef.current[i] = el)}
                          type="text"
                          inputMode="numeric"
                          maxLength={1}
                          value={d}
                          className="otp-input"
                          onChange={(e) => handleCodigoChange(i, e.target.value)}
                          onKeyDown={(e) => handleCodigoKey(i, e)}
                          autoFocus={i === 0}
                      />
                  ))}
                </div>
                <button
                    type="submit"
                    className="btn btn-primary btn-lg"
                    style={{ width: "100%" }}
                    disabled={cargando || codigo.join("").length !== 6}
                >
                  {cargando ? "Verificando..." : "🔐 Verificar código"}
                </button>
                <button
                    type="button"
                    className="btn btn-ghost btn-sm"
                    style={{ width: "100%" }}
                    onClick={() => { setPaso(1); setCodigo(["", "", "", "", "", ""]); }}
                >
                  ← Volver
                </button>
              </form>
          )}
        </div>
      </div>
  );
}